import { NavLink, To, useNavigate } from "react-router-dom";
import {
  BarChartFill,
  Tag,
  FiletypeCsv,
  CardList,
  QrCodeScan,
  FileCodeFill,
  FilterSquareFill,
} from "react-bootstrap-icons";
//import styles from "./sidebar.module.css";
import "./sidepanel.css";
import { Roles } from "../../utils/enums";
import GetAllowedRoutes from "../../Routes/allowedRoutes";
import mainlogo from "../../Assets/Images/main-logo.png";
import SideNav, {
  // Toggle,
  // Nav,
  NavItem,
  NavIcon,
  NavText,
} from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import FeatherIcon from "feather-icons-react";

type IMenuProps = {
  path: To;
  title: String;
  icon: any;
  permission: Array<String>;
};

export const AdminMenu: Array<IMenuProps> = [
  {
    path: "/admin",
    title: "Admin",
    icon: <BarChartFill size={20} />,
    permission: [Roles.ADMIN],
  },
  {
    path: "/ads-dashboard",
    title: "Ads Dashboard",
    icon: <FeatherIcon icon="pie-chart" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.ADSD],
  },
  {
    path: "/manager",
    title: "Tag Generator",
    icon: <Tag size={20} />,
    permission: [Roles.ADMIN, Roles.TAGGER],
  },
  {
    path: "/imageTester",
    title: "Image Testser",
    icon: <QrCodeScan size={20} />,
    permission: [Roles.ADMIN, Roles.TAGGER, Roles.TESTER],
  },
  // {
  //   path: "/GLU",
  //   title: "GLU",
  //   icon: <FeatherIcon icon="mail" className="icon-dual" />,
  //   permission: [Roles.ADMIN, Roles.GLU],
  // },
  {
    path: "/targeting",
    title: "Targeting Config",
    icon: <FiletypeCsv size={20} />,
    permission: [Roles.ADMIN, Roles.SEGMENT],
  },
  {
    path: "/reporter",
    title: "OP Reporting",
    icon: <CardList size={20} />,
    permission: [Roles.ADMIN, Roles.OPREPORTING],
  },
  // {
  //   path: '/s3Loader',
  //   title: 'S3-UPLOADER',
  //   icon: <CloudUpload size={20} />,
  //   permission: [Roles.ADMIN, Roles.SEGMENT]
  // },
  // {
  //   path: "/jsConfig",
  //   title: "JSC",
  //   icon: <FileCode size={20} />,
  //   permission: [Roles.ADMIN, Roles.SPECIAL, Roles.JS_CONFIG],
  // },
  {
    path: "/Campaigns",
    title: "Campaigns",
    icon: <FileCodeFill size={20} />,
    permission: [Roles.ADMIN, Roles.CAMP],
  },
  {
    path: "/uploadAudience",
    title: "UPLOAD AUDIENCE",
    icon: <FeatherIcon icon="target" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.CTARGET],
  },
  {
    path: "/eventsLogger",
    title: "Events Logger",
    icon: <FeatherIcon icon="terminal" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.CLOGGER],
  },
  {
    path: "/adsImpressions",
    title: "Ads Impressions",
    icon: <FeatherIcon icon="bookmark" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.AIMP],
  },
  {
    path: "/bidRequests",
    title: "Bid Requests",
    icon: <FeatherIcon icon="database" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN,Roles.BID_REQUESTS],
  },
  {
    path: "/realtimeMonitor",
    title: "Realtime Monitor",
    icon: <FeatherIcon icon="server" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN,Roles.REALTIME_MONITOR],
  },
  {
    path: "/userManagement",
    title: "User Management",
    icon: <FeatherIcon icon="users" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN,Roles.SUPER_USER],
  },
  {
    path: "/ipFiltering",
    title: "Prod IP Filtering",
    icon: <FeatherIcon icon="filter" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.PROD_FILTERING],
  },
  {
    path: "/ipFilteringDemo",
    title: "Demo IP Filtering",
    icon: <FilterSquareFill size={20} />,
    permission: [Roles.ADMIN, Roles.DEMO_FILTERING],
  },
  {
    path: "/opCreativeUpload",
    title: "OP CREATIVE UPLOAD",
    icon: <FeatherIcon icon="image" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.OP_CREATIVE_UPLOAD],
  },
  {
    path: "/creativeUpload",
    title: "CREATIVE UPLOAD",
    icon: <FeatherIcon icon="image" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.CREATIVE_UPLOAD],
  },
  {
    path: "/userSyncInfo1",
    title: "USER SYNC INFO 1",
    icon: <FeatherIcon icon="user" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.USER_INFO],
  },
  {
    path: "/userAPIInfo2",
    title: "USER API INFO 2",
    icon: <FeatherIcon icon="user" className="icon-dual" size={20} />,
    // permission: [Roles.ADMIN, Roles.USER_INFO_V2],
    permission: [Roles.ADMIN, Roles.USER_INFO_V2],
  },
  {
    path: "/userinfo",
    title: "USER INFO",
    icon: <FeatherIcon icon="user" className="icon-dual" size={20} />,
    // permission: [Roles.ADMIN, Roles.USER_INFO_V2],
    permission: [Roles.ADMIN, Roles.USER_INFO_NG],
  },
  {
    path: "/yandex",
    title: "YANDEX",
    icon: <FeatherIcon icon="align-justify" className="icon-dual" size={20} />,
    permission: [Roles.ADMIN, Roles.YANDEX]
  },
];

const SidePanelComponent = (props: any) => {
  const { isVisible, setIsVisible } = props;
  //const location = useLocation()
  const nevigate = useNavigate();
  // const [isVisible, setIsVisible] = useState(false)

  const navMargin = isVisible ? "0px" : "50px";

  return (
    <>
      {/* <div className={styles.dashboard_sidebar}>
        <div className={styles.sidebar_content}>
          <div className={styles.dashboard_logo} style={{ padding: '0 25px 10px 25px' }}>
            <NavLink to="/" className="text-decoration-none">
              <h3>
                <img style={{
                  width: '30px',
                  height: '30px',
                  objectFit: 'contain'
                }} src={mainlogo} />
              </h3>
            </NavLink>
          </div>
          <div className={styles.sidebar_content_list} style={{ background: ' #464242' }}>
            {GetAllowedRoutes(AdminMenu).map((item: IMenuProps, index: number) => (
              <NavLink
                key={index}
                to={item.path}
                onClick={() => handleClick && handleClick()}
                className={({ isActive }) => (isActive || location.pathname === item.path ? styles.active : '' && "d-flex align-items-center")}
              >
                <div className="mx-3">{item.icon}</div>
                <h6 className="m-0">{item.name}</h6>
              </NavLink>
            ))}
          </div>
        </div>
      </div> */}

      <SideNav
        expanded={isVisible}
        onToggle={(toggle: boolean) => setIsVisible(toggle)}
        className="topbar"
        style={{ height: " 100vh", overflowY: "auto", overflowX: " hidden" }}
      >
        {/* <div
          className={styles.dashboard_logo}
          style={{
            // padding: "20px 10px 60px",
            padding: "20px 10px",
            display: " flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "fixed",
            width: "240px",
            background: " #ffff",
            height: "70px",
            zIndex: "99",
            borderBottom: "1px solid #ddd",
          }}
        > */}
        <NavLink
          to={GetAllowedRoutes(AdminMenu)?.[0]?.path}
          className="text-decoration-none logo-image"
        >
          <h3>
            <img
              alt=""
              style={{
                width: "30px",
                height: "30px",
                objectFit: "contain",
              }}
              src={mainlogo}
            />
          </h3>
        </NavLink>
        <SideNav.Toggle />

        {/* </div> */}
        <SideNav.Nav
          style={{
            marginTop: navMargin, //"70px",
            marginBottom: "70px",
            paddingBottom: "100px",
          }}
        >
          {/* <div className={styles.sidebar_content_list} style={{ background: ' #464242' }}>
            {GetAllowedRoutes(AdminMenu).map((item: IMenuProps, index: number) => (
              <NavLink
                key={index}
                to={item.path}
                onClick={() => handleClick && handleClick()}
                className={({ isActive }) => (isActive || location.pathname === item.path ? styles.active : '' && "d-flex align-items-center")}
              >
                <div className="mx-3">{item.icon}</div>
                <h6 className="m-0">{item.name}</h6>
              </NavLink>
            ))}
          </div> */}

          {GetAllowedRoutes(AdminMenu).map(
            (item: IMenuProps, index: number) => (
              <NavItem
                key={index}
                eventKey={item.path}
                onClick={(event: any) => nevigate(item?.path)}
                active={item?.path === window.location.pathname}
                className="navvv"
                selected="reddd"
              >
                <NavIcon>
                  <div className="mx-3">{item.icon}</div>
                </NavIcon>
                <NavText>
                  {" "}
                  <div className="color-name">{item.title}</div>
                </NavText>
              </NavItem>
            )
          )}
        </SideNav.Nav>
      </SideNav>
    </>
  );
};

export default SidePanelComponent;
